import {
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SoftlineEntityService,
  Store,
  StoreModule,
} from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_API_ABSATZPLAN_ENTITY } from './absatzplan.api';
import {
  SOFTLINE_FEATURE_ABSATZPLAN,
  SOFTLINE_FEATURE_ABSATZPLAN_VERSIONEN,
} from './absatzplan.shared';
import { AbsatzplanService } from './services/absatzplan.service';
import { AbsatzplanStore } from './store/absatzplan.store';
import { AbsatzplanVersionenStore } from './store/versionen.store';
import { absatzplanRoutes } from './absatzplan.routes';
import { provideAbsatzplanGlobals } from './absatzplan.globals';

export function provideAbsatzplanModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'absatzplan',
        title: 'Absatzpläne',
        icon: 'fa-regular fa-file-invoice-dollar',
        route: '/absatzplan',
        permission: 'ABSATZPLAN',
        group: getModuleGroupByName('Produktion'),
      },
      withSoftAppsModuleRoutes({ app: absatzplanRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/produktion/absatzplan',
        description: 'Absatzpläne der Produktion.',
      })
    ),
    ...provideAbsatzplanGlobals(),
  ];
}

export const absatzplanProviders = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'absatzplan',
      language: 'de',
      translations: de,
    });

    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Absatzpläne',
      icon: 'fa-regular fa-file-invoice-dollar',
      route: '/absatzplan',
      permission: 'ABSATZPLAN',
      group: getModuleGroupByName('Produktion'),
    });
  }),
  {
    provide: AbsatzplanService,
    useClass: AbsatzplanService,
  },
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_ABSATZPLAN,
      feature: AbsatzplanStore.feature,
    }),
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_ABSATZPLAN_VERSIONEN,
      feature: AbsatzplanVersionenStore.feature,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: () =>
            new SoftlineEntityService(
              inject(SOFTLINE_SERVICE_HTTP),
              SOFTLINE_API_ABSATZPLAN_ENTITY
            ),
        },
      ],
    })
  ),
];
